import { render, staticRenderFns } from "./NsipsCard.vue?vue&type=template&id=1eef8abf&"
import script from "./NsipsCard.vue?vue&type=script&lang=js&"
export * from "./NsipsCard.vue?vue&type=script&lang=js&"
import style0 from "./NsipsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports